import React, {useState, useCallback, useEffect} from 'react'
import {useDropzone} from 'react-dropzone';

// DemoUploadAudioDiv
function DemoUploadAudioDiv(props) {

  const onDrop = useCallback(acceptedFiles => {

    props.fileSlected(acceptedFiles)

  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

  return (
    <div {...getRootProps({className: 'dropzone'})}>
      <input {...getInputProps()} />
      <p>音声ファイルをドロップ</p>
    </div>
  );
}

export default DemoUploadAudioDiv
